// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2AZEp","validationTips":"StatementDescriptor_validationTips__1cVYl"};